import React from 'react';
import EditDoctorForm from '../../components/EditDoctorForm';

function EditDoctorData() {
  return (
    <main>
      <div className='mx-auto max-w-7xl sm:px-6 lg:px-8'>
        <div className='px-4 sm:px-0'>
          <EditDoctorForm />
        </div>
      </div>
    </main>
  );
}

export default EditDoctorData;
